import { useTranslation } from 'react-i18next'

import { useAppRoot } from './RootContext'
import { DownloadButton } from '../utils/Buttons'
import { exportToFile } from '../utils/Helpers'

export const ProjectsEditorCSVExportButton = () => {
    const { t } = useTranslation()
    const appRoot = useAppRoot()
    const SEPARATOR = `\t`

    const handleDownloadCSV = () => {
        if (!appRoot?.rts?.length) return

        const headers = [t('Group'), t('Project')]

        const rows = appRoot
            .getAllProjectRootsSorted()
            .map(({ group, project }) => [group ?? '', project.getFormattedDisplayName()])

        const tsvContent = [headers, ...rows].map((row) => row.join(SEPARATOR)).join('\n')
        const blob = new Blob([tsvContent], { type: 'text/tab-separated-values;charset=utf-8;' })

        exportToFile(blob, 'AVTT-projects', '.csv')
    }

    return (
        <DownloadButton className="csv-export-button" enabled onClick={handleDownloadCSV} tooltip={t('exportAsCSV')} />
    )
}
